module.exports = __webpack_public_path__ + "static/media/73-nc.6fcc8d0c.jpg";